import Model from "../Model";

class Comercialbubbledetail extends Model{

    buildUrl ({ param }) {
        return ['zoneview/detailsbyzoneid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Comercialbubbledetail;